import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { authAPI } from './services/api'

// Import pages
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import ResiliencePage from './pages/ResiliencePage'
import PredictorsPage from './pages/PredictorsPage'
import RankingsPage from './pages/RankingsPage'
import AnalysisPage from './pages/AnalysisPage'
import NewUserPage from './pages/NewUserPage'
import PlaysPage from './pages/PlaysPage'
import OptimalPacePage from './pages/OptimalPacePage'

// Import components
import Navigation from './components/Navigation'

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = authAPI.isAuthenticated()
  return isAuthenticated ? children : <Navigate to="/login" replace />
}

// Layout component for authenticated pages
const AppLayout = ({ children }) => (
  <>
    <Navigation />
    {children}
  </>
)

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route 
          path="/login" 
          element={
            authAPI.isAuthenticated() ? 
            <Navigate to="/dashboard" replace /> : 
            <LoginPage />
          } 
        />
        
        {/* Protected routes */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <AppLayout>
              <DashboardPage />
            </AppLayout>
          </ProtectedRoute>
        } />
        
        <Route path="/resilience" element={
          <ProtectedRoute>
            <AppLayout>
              <ResiliencePage />
            </AppLayout>
          </ProtectedRoute>
        } />
        
        <Route path="/predictors" element={
          <ProtectedRoute>
            <AppLayout>
              <PredictorsPage />
            </AppLayout>
          </ProtectedRoute>
        } />
        
        <Route path="/rankings" element={
          <ProtectedRoute>
            <AppLayout>
              <RankingsPage />
            </AppLayout>
          </ProtectedRoute>
        } />
        
        <Route path="/analysis" element={
          <ProtectedRoute>
            <AppLayout>
              <AnalysisPage />
            </AppLayout>
          </ProtectedRoute>
        } />
        
        <Route path="/new-user" element={
          <ProtectedRoute>
            <AppLayout>
              <NewUserPage />
            </AppLayout>
          </ProtectedRoute>
        } />
        
        <Route path="/plays" element={
          <ProtectedRoute>
            <AppLayout>
              <PlaysPage />
            </AppLayout>
          </ProtectedRoute>
        } />
        
        <Route path="/optimal-pace" element={
          <ProtectedRoute>
            <AppLayout>
              <OptimalPacePage />
            </AppLayout>
          </ProtectedRoute>
        } />
        
        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  )
}

export default App 